/**
 * @generated SignedSource<<6fb54b74a2cdb8975438579ca74f56bb>>
 * @relayHash 1bb9f4ed5bfbcdceb4c4b7815eddf2f4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3c92e138c9ea9d124f98e82ddb0e907fa61396129dd431b760e8f235ec8e7c8d

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CcpEntitlementPreDunningStatus = "IN_PRE_DUNNING" | "NOT_IN_PRE_DUNNING" | "%future added value";
export type JiraApplicationKey = "JIRA_CORE" | "JIRA_PRODUCT_DISCOVERY" | "JIRA_SERVICE_DESK" | "JIRA_SOFTWARE" | "%future added value";
export type CommerceEntitlementFilter = {
  AND?: ReadonlyArray<CommerceEntitlementFilter | null | undefined> | null | undefined;
  OR?: ReadonlyArray<CommerceEntitlementFilter | null | undefined> | null | undefined;
  inPreDunning?: boolean | null | undefined;
  inTrialOrPreDunning?: boolean | null | undefined;
};
export type editionAwarenessQuery$variables = {
  applicationKey: JiraApplicationKey;
  chargeElement: string;
  cloudId: string;
  entitlementFilter?: CommerceEntitlementFilter | null | undefined;
  productKey: string;
  shouldCheckBillingAdmin: boolean;
  shouldCheckForChangeOffering: boolean;
  shouldCheckForChargeQuantities: boolean;
  shouldCheckForStorageUsageConfluence: boolean;
  shouldCheckForStorageUsageJira: boolean;
  shouldCheckForTrial: boolean;
  shouldCheckForTwc: boolean;
  shouldSkip: boolean;
  trialOfferingName: string;
};
export type editionAwarenessQuery$data = {
  readonly tenantContexts?: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly __typename: string;
        readonly experienceCapabilities?: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly offering?: {
          readonly trial: {
            readonly lengthDays: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly preDunning?: {
          readonly status: CcpEntitlementPreDunningStatus | null | undefined;
        } | null | undefined;
        readonly relatesFromEntitlements?: ReadonlyArray<{
          readonly entitlementId: string | null | undefined;
          readonly relationshipType: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly subscription?: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly experienceCapabilities: {
                readonly configurePaymentV2: {
                  readonly experienceUrl: string | null | undefined;
                  readonly isAvailableToUser: boolean | null | undefined;
                } | null | undefined;
              } | null | undefined;
              readonly invoiceable: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly trial: {
            readonly timeLeft: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly transactionAccount?: {
          readonly isCurrentUserBillingAdmin: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"audienceAndTiming_AtlassianEditionAwareness">;
};
export type editionAwarenessQuery = {
  response: editionAwarenessQuery$data;
  variables: editionAwarenessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chargeElement"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entitlementFilter"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckBillingAdmin"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForChangeOffering"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForChargeQuantities"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageUsageConfluence"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageUsageJira"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForTrial"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForTwc"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldSkip"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trialOfferingName"
},
v14 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v15 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v16 = [
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "entitlementFilter"
  }
],
v17 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v18 = [
  {
    "kind": "Variable",
    "name": "offeringName",
    "variableName": "trialOfferingName"
  }
],
v19 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v20 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v21 = {
  "kind": "ScalarField",
  "name": "status"
},
v22 = {
  "kind": "ScalarField",
  "name": "timeLeft"
},
v23 = {
  "kind": "ScalarField",
  "name": "invoiceable"
},
v24 = {
  "kind": "ScalarField",
  "name": "lengthDays"
},
v25 = {
  "kind": "ScalarField",
  "name": "isCurrentUserBillingAdmin"
},
v26 = {
  "kind": "ScalarField",
  "name": "relationshipType"
},
v27 = {
  "kind": "ScalarField",
  "name": "entitlementId"
},
v28 = {
  "kind": "ScalarField",
  "name": "id"
},
v29 = [
  (v28/*: any*/)
],
v30 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Fragment",
    "name": "editionAwarenessQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "audienceAndTiming_AtlassianEditionAwareness"
      },
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v14/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v15/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  {
                    "args": (v16/*: any*/),
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "condition": "shouldCheckForChangeOffering",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "experienceCapabilities",
                            "plural": false,
                            "selections": [
                              {
                                "args": (v18/*: any*/),
                                "kind": "LinkedField",
                                "name": "changeOfferingV2",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/),
                                  (v20/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckForTrial",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "preDunning",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v22/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v23/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "experienceCapabilities",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "configurePaymentV2",
                                            "plural": false,
                                            "selections": [
                                              (v20/*: any*/),
                                              (v19/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "offering",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v24/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckBillingAdmin",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "transactionAccount",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckForTwc",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "relatesFromEntitlements",
                            "plural": true,
                            "selections": [
                              (v26/*: any*/),
                              (v27/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v13/*: any*/),
      (v6/*: any*/),
      (v10/*: any*/),
      (v12/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v11/*: any*/),
      (v9/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "editionAwarenessQuery",
    "selections": [
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v14/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v15/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  {
                    "args": (v16/*: any*/),
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "condition": "shouldCheckForChargeQuantities",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "chargeElement",
                                "variableName": "chargeElement"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "latestUsageForChargeElement"
                          }
                        ]
                      },
                      (v28/*: any*/),
                      {
                        "condition": "shouldCheckForChangeOffering",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "experienceCapabilities",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              {
                                "args": (v18/*: any*/),
                                "kind": "LinkedField",
                                "name": "changeOfferingV2",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckForTrial",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "preDunning",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              (v21/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v22/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v23/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "experienceCapabilities",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "name": "configurePaymentV2",
                                            "plural": false,
                                            "selections": [
                                              (v17/*: any*/),
                                              (v20/*: any*/),
                                              (v19/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v29/*: any*/),
                                        "type": "CcpInvoiceGroup"
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v29/*: any*/),
                                "type": "CcpSubscription"
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "offering",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v24/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v29/*: any*/),
                                "type": "Node",
                                "abstractKey": "__isNode"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckBillingAdmin",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "transactionAccount",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              (v25/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v29/*: any*/),
                                "type": "CcpTransactionAccount"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckForTwc",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "relatesFromEntitlements",
                            "plural": true,
                            "selections": [
                              (v17/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldCheckForStorageUsageJira",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "applicationKey",
                    "variableName": "applicationKey"
                  },
                  (v30/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "attachmentStorageUsed"
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldCheckForStorageUsageConfluence",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v30/*: any*/)
            ],
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "bytesUsed"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3c92e138c9ea9d124f98e82ddb0e907fa61396129dd431b760e8f235ec8e7c8d",
    "metadata": {},
    "name": "editionAwarenessQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "482b3db87cad9ffcc5dac49733c4646a";

export default node;
